import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mergeMap, catchError, of, tap } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { FirebaseError } from "firebase/app";
import { ToastrService } from "ngx-toastr";
import { VideoActionTypes, ErrorVideo, ListVideoSuccess, UpdateVideoSuccess } from "@Actions/video.action";
import { VideoService } from "@Services/video.service";
import { Video } from "@Models/video.model";


@Injectable()
export class VideoEffects {

    constructor(
        private actions$: Actions,
        private videoService: VideoService,
        private logger: NGXLogger,
        private toastrService: ToastrService,
    ) {}

    listVideos$ = createEffect(() =>
        this.actions$.pipe(
            ofType(VideoActionTypes.LIST_VIDEO),
            mergeMap((action: any) => {
                return this.videoService.getVideos({ isDeleted: false })
                    .pipe(
                        map((videos: Video[]) => {
                            this.logger.info('Liste des video', videos.length);
                            return new ListVideoSuccess(videos);
                        }),
                        catchError((err: FirebaseError) => {
                            this.logger.error('login fail', err.code, err.message);
                            return of(new ErrorVideo("Une erreur est survenue lors du chargement des videos"));
                        })
                    )
            })
        )
    );

    updateVideo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(VideoActionTypes.UPDATE_VIDEO),
            mergeMap((action: any) => {
                return this.videoService.updateVideo(action.payload)
                    .pipe(
                        map((result) => {
                            this.logger.info("mise a jour de l'video", action.payload);
                            return new UpdateVideoSuccess("Modification reussie");
                        }),
                        catchError((err: FirebaseError) => {
                            this.logger.error('login fail', err.code, err.message);
                            return of(new ErrorVideo("Une erreur est survenue lors du chargement des videos"));
                        })
                    )
            })
        )
    );


    updateVideoSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(VideoActionTypes.UPDATE_VIDEO_SUCCESS),
        tap((action: any) => this.toastrService.success(action.payload))
    ), { dispatch: false });

    errorVideo$ = createEffect(() => this.actions$.pipe(
        ofType(VideoActionTypes.ERROR_VIDEO),
        tap((action: any) => this.toastrService.error(action.payload))
    ), { dispatch: false });
}